import React from 'react';
import { IconButton, Box } from '@mui/material';
import theme from '../../theme';
import starIcon from '../../assets/star_primary.svg';
import starOutlinedIcon from '../../assets/star_outliend_b3.svg';

const StarButton = ({ isStarred, onToggle }) => {
  return (
    <IconButton
      disableRipple
      onClick={onToggle}
      aria-label="toggle star"
      sx={{
        width: { xs: 32, md: 40 },
        height: { xs: 32, md: 40 },
        p: 1,
        border: `1px solid ${theme.palette.grey.line}`,
        borderRadius: 1,
      }}
    >
      <Box
        component="img"
        src={isStarred ? starIcon : starOutlinedIcon}
        alt="star icon"
        sx={{
          width: { xs: 16, md: 24 },
          height: { xs: 16, md: 24 },
        }}
      />
    </IconButton>
  );
};

export default StarButton;
